export function deleteUnnecessary(data,type) {
    for(const key in data){
        if(key == 'name' && type == "work"){
          delete data["name"];
        }
        if(key == 'id'){
          delete data["id"];
        }
        if(key == 'created_at'){
          delete data["created_at"]
        }
        if(key == 'updated_at'){
          delete data["updated_at"];
        }
    }
    return data;
}